/**
 * Ambient types for the WebMCP imperative API (`document.modelContext`).
 * The API is experimental and not yet in lib.dom.d.ts, so we declare the
 * subset the imperative API surfaces. Verified against the Chrome
 * developer docs and the WHATWG/W3C webmachinelearning/webmcp explainer.
 */
export function isWebMCPAvailable() {
    return typeof document !== "undefined" && !!document.modelContext?.registerTool;
}
